const reviews = [
  {
    name: 'Emre K.',
    location: 'İstanbul, TR',
    flag: '🇹🇷',
    avatar: 'https://readdy.ai/api/search-image?query=young%20turkish%20man%20portrait%2C%20professional%20headshot%2C%20dark%20background%2C%20confident%20smile%2C%20urban%20modern%20style%2C%20soft%20studio%20lighting%2C%20realistic%20photo&width=120&height=120&seq=rev1&orientation=squarish',
    text: 'Premium\'a geçtiğimde eşleşme süresi dramatik şekilde düştü. Cinsiyet filtresi sayesinde çok daha kaliteli sohbetler yapıyorum.',
    plan: 'Premium',
    rating: 5,
  },
  {
    name: 'Sarah M.',
    location: 'Berlin, DE',
    flag: '🇩🇪',
    avatar: 'https://readdy.ai/api/search-image?query=young%20european%20woman%20portrait%2C%20professional%20headshot%2C%20dark%20background%2C%20warm%20smile%2C%20modern%20casual%20style%2C%20studio%20lighting%2C%20realistic%20photo&width=120&height=120&seq=rev2&orientation=squarish',
    text: 'Ülke filtresini açtığımda sadece Almanya\'dan insanlarla eşleşiyorum. Bu özellik benim için oyun değiştirici oldu!',
    plan: 'Premium+',
    rating: 5,
  },
  {
    name: 'Kenji T.',
    location: 'Tokyo, JP',
    flag: '🇯🇵',
    avatar: 'https://readdy.ai/api/search-image?query=young%20japanese%20man%20portrait%2C%20clean%20professional%20headshot%2C%20dark%20neutral%20background%2C%20subtle%20smile%2C%20modern%20style%2C%20studio%20lighting%20photo&width=120&height=120&seq=rev3&orientation=squarish',
    text: 'Reklamsız deneyim tek başına değiyor. Artık sohbet ortasında reklam kesilmiyor, çok daha akıcı bir deneyim.',
    plan: 'Premium',
    rating: 5,
  },
  {
    name: 'Ayşe D.',
    location: 'Ankara, TR',
    flag: '🇹🇷',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%2C%20professional%20headshot%2C%20dark%20background%2C%20friendly%20expression%2C%20modern%20casual%20style%2C%20realistic%20studio%20photo&width=120&height=120&seq=rev4&orientation=squarish',
    text: 'Yeniden bağlan özelliği harika! Bağlantı koptuğunda aynı kişiyle tekrar eşleşebiliyorsunuz, bu muhteşem.',
    plan: 'Premium+',
    rating: 5,
  },
];

const StarRating = ({ count }: { count: number }) => (
  <div className="flex items-center gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <i key={i} className={`ri-star-fill text-xs ${i < count ? 'text-yellow-400' : 'text-white/15'}`} />
    ))}
  </div>
);

const PremiumTestimonials = () => {
  return (
    <section className="py-16 md:py-20 bg-[#05070d]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-500/10 border border-yellow-500/25 text-yellow-400 text-xs font-semibold mb-5">
            <i className="ri-star-line" />
            Kullanıcı Yorumları
          </div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-3">
            Premium Üyeler Ne Diyor?
          </h2>
          <p className="text-white/40 text-sm md:text-base">
            500.000+ mutlu Premium kullanıcıdan gerçek yorumlar.
          </p>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reviews.map((rev) => (
            <div
              key={rev.name}
              className="flex flex-col p-6 rounded-2xl bg-white/3 border border-white/8 hover:bg-white/5 hover:border-white/12 transition-all duration-300"
            >
              {/* Stars */}
              <StarRating count={rev.rating} />

              {/* Quote */}
              <p className="text-white/65 text-sm leading-relaxed mt-4 mb-6 flex-1">
                "{rev.text}"
              </p>

              {/* User */}
              <div className="flex items-center gap-3 pt-4 border-t border-white/8">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-white/5">
                  <img
                    src={rev.avatar}
                    alt={rev.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-white font-semibold text-sm truncate">{rev.name}</div>
                  <div className="text-white/35 text-xs flex items-center gap-1 truncate">
                    <span>{rev.flag}</span>
                    <span>{rev.location}</span>
                  </div>
                </div>
                <div
                  className={`px-2 py-1 rounded-full text-xs font-bold flex-shrink-0 ${
                    rev.plan === 'Premium+'
                      ? 'bg-cyan-500/15 text-cyan-400 border border-cyan-500/25'
                      : 'bg-yellow-500/15 text-yellow-400 border border-yellow-500/25'
                  }`}
                >
                  {rev.plan}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PremiumTestimonials;
